import React, {FC, PropsWithChildren} from 'react';
import LaptopSizeWrapper from 'components/ContentPagesComponents/LaptopSizeWrapper';
import {BG} from 'constants/index';

import './index.scss';

const ClientsPanel: FC<PropsWithChildren> = ({children}) => {
	return (
		<LaptopSizeWrapper bg={BG.light}>
			<div className='clients-panel'>
				{children}
			</div>
		</LaptopSizeWrapper>
	);
};

export default ClientsPanel;
